// extracted by mini-css-extract-plugin
export default {"wrapper":"ZC-z","viewport":"_C-z","container":"aD-z","slide":"bD-z"};